import {useCallback, useState} from "react";
import {createBsrsSurvey} from "../api/createBsrsSurvey";

export const useCreateBsrsSurvey = ({ age, gender, score, answers, onCompleted } )=> {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const submit = useCallback(async () => {
    setIsLoading(true);
    await createBsrsSurvey({ age, gender, score, answers });
    setIsLoading(false);
    onCompleted()
  }, [age, answers, gender, onCompleted, score])

  return { isLoading, submit }
}